import { useEffect, useState } from "react";
import {
  STORAGE_KEY,
  REOPEN_KEY,
  isConsentRequiredRegion,
  updateConsent,
} from "@/lib/consent";

export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "granted" || stored === "denied") {
      updateConsent(stored);
      return;
    }
    if (sessionStorage.getItem(REOPEN_KEY)) {
      updateConsent("denied");
      setVisible(true);
      return;
    }

    isConsentRequiredRegion().then((required) => {
      if (!cancelled && required) {
        updateConsent("denied");
        setVisible(true);
      }
    });

    return () => {
      cancelled = true;
    };
  }, []);

  const decide = (decision: "granted" | "denied") => {
    localStorage.setItem(STORAGE_KEY, decision);
    sessionStorage.removeItem(REOPEN_KEY);
    updateConsent(decision);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-modal="false"
      aria-label="Preferenze cookie"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-border bg-background p-4 shadow-[var(--shadow-soft)] sm:p-5"
    >
      <div className="mx-auto flex max-w-4xl flex-col gap-4 sm:flex-row sm:items-center">
        <p className="text-sm leading-relaxed text-foreground/90">
          Usiamo i cookie di misurazione per capire quanti contatti arrivano dagli annunci
          e dal sito. Puoi accettare oppure continuare senza.
        </p>
        <div className="flex shrink-0 gap-2">
          <button
            type="button"
            onClick={() => decide("denied")}
            className="rounded-xs border border-border px-4 py-2.5 text-sm font-semibold transition-colors hover:bg-secondary"
          >
            Continua senza
          </button>
          <button
            type="button"
            onClick={() => decide("granted")}
            className="rounded-xs bg-primary px-4 py-2.5 text-sm font-semibold text-primary-foreground transition-colors hover:bg-sienna"
          >
            Accetta
          </button>
        </div>
      </div>
    </div>
  );
}
